import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/_base.interfaces';
import { Type } from '../interfaces/type';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TypesService {
  path = `${environment.serverUrl}`;

  constructor(private _http: HttpClient) { }

  public getTypes(): Observable<any> {
    return this._http.get<ApiResponse<Type[]>>(`${this.path}/types`);
  }
}
